import React from 'react';
import { Header, Table } from 'semantic-ui-react';

import { escribirMonto } from '../../utilidades';

interface TablaTotalPagosPorAreaProps {
    totalPagosDelDiaPreu: number;
    totalPagosDelDiaIngles: number;
    totalPagosCuotasYCobrosCalculadosDelDia: number;
}

const TablaTotalPagosPorArea: React.FunctionComponent<TablaTotalPagosPorAreaProps> = props => {
    const {
        totalPagosDelDiaPreu,
        totalPagosDelDiaIngles,
        totalPagosCuotasYCobrosCalculadosDelDia,
    } = props;
    return (
        <div>
            <Header as='h4'>Total pagos por área</Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={12}>Área</Table.HeaderCell>
                        <Table.HeaderCell width={4}>Total</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>Preuniversitario</Table.Cell>
                        <Table.Cell>{escribirMonto(totalPagosDelDiaPreu)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Ingles</Table.Cell>
                        <Table.Cell>{escribirMonto(totalPagosDelDiaIngles)}</Table.Cell>
                    </Table.Row>
                    <Table.Row warning>
                        <Table.Cell>Total</Table.Cell>
                        <Table.Cell>
                            {escribirMonto(totalPagosCuotasYCobrosCalculadosDelDia)}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );
};

export default TablaTotalPagosPorArea;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/Componentes/TablaTotalPagosPorArea.tsx